import script from "./AlertContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertContainer.vue?vue&type=script&setup=true&lang=js"

import "./AlertContainer.vue?vue&type=style&index=0&id=0f1ea3c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1ea3c6"]])

export default __exports__